import SportCode from "components/common/SportCode";
import React from "react";

export function CompetitorBlockNoData(competitor) {
    let competitorPrev = !competitor.cp_prev_wlt ? competitor?.cp_prev_pos : ''
    competitorPrev = competitor?.cp_code === 'BYE' ? SportCode({ entity: '@CompetitorPlace', code: competitor?.cp_code, abbr: true }) : competitorPrev
    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div></div>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className=''>{competitorPrev} </div>
            {/* <div className='score-name'>{competitor?.cp_prev_pos}  </div>*/}
        </div>
    )
}
